import { render, staticRenderFns } from "./MemberOto.vue?vue&type=template&id=050a9294&scoped=true&"
import script from "./MemberOto.vue?vue&type=script&lang=js&"
export * from "./MemberOto.vue?vue&type=script&lang=js&"
import style0 from "./MemberOto.vue?vue&type=style&index=0&id=050a9294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050a9294",
  null
  
)

export default component.exports